import { tsValidateGeneralUrl, tsValidateShortUrl, tsValidateString } from '@nu-art/ts-common';
const Validator_ModifiableProps = {
    fullUrl: tsValidateGeneralUrl(true),
    title: tsValidateString(),
    description: tsValidateString(undefined, false),
};
const Validator_GeneratedProps = {
    _shortUrl: tsValidateShortUrl(),
};
export const DBDef_ShortUrl = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'short-url',
    entityName: 'short-url',
    frontend: {
        group: 'app',
        name: 'short-url'
    },
    backend: {
        name: 'short-url'
    }
};
//# sourceMappingURL=db-def.js.map